export default "__VITE_ASSET__Driybug$__"